/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Goal_RunningInputs */

const en_portal_goal_running = /** @type {(inputs: Portal_Goal_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running`)
};

const pl_portal_goal_running = /** @type {(inputs: Portal_Goal_RunningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bieganie`)
};

/**
* | output |
* | --- |
* | "Running" |
*
* @param {Portal_Goal_RunningInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_goal_running = /** @type {((inputs?: Portal_Goal_RunningInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Goal_RunningInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_goal_running(inputs)
	return en_portal_goal_running(inputs)
});